/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CameraErrorPayload
 */
export interface CameraErrorPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: CameraErrorPayloadTypeEnum;
    /**
     * 
     */
    errorMessage: string;
}


/**
 * @export
 */
export const CameraErrorPayloadTypeEnum = {
    CameraError: 'camera_error',
} as const;
export type CameraErrorPayloadTypeEnum = typeof CameraErrorPayloadTypeEnum[keyof typeof CameraErrorPayloadTypeEnum];


/**
 * Check if a given object implements the CameraErrorPayload interface.
 */
export function instanceOfCameraErrorPayload(value: object): value is CameraErrorPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'camera_error') return false;
    
    if ((!('errorMessage' in (value as Record<string, any>)) && !('error_message' in (value as Record<string, any>))) || ((value as Record<string, any>)['errorMessage'] === undefined && (value as Record<string, any>)['error_message'] === undefined)) return false;
    return true;
}

export function CameraErrorPayloadFromJSON(json: any): CameraErrorPayload {
    return CameraErrorPayloadFromJSONTyped(json, false);
}

export function CameraErrorPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CameraErrorPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'errorMessage': json['error_message'],
    };
}

export function CameraErrorPayloadToJSON(json: any): CameraErrorPayload {
    return CameraErrorPayloadToJSONTyped(json, false);
}

export function CameraErrorPayloadToJSONTyped(value?: CameraErrorPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'error_message': value['errorMessage'],
    };
}

